export default "__VITE_ASSET__28d4c306__"